export const SET_LOADING = "SET_LOADING";

export const SET_INVITATIONS = "SET_INVITATIONS";

export const UPDATE_INVITATION = "UPDATE_INVITATION";

export const DELETE_INVITATION = "DELETE_INVITATION";

export const TOGGLE_SHOW_REJECT_INVITATION_DIALOG = "TOGGLE_SHOW_REJECT_INVITATION_DIALOG";

export const TOGGLE_SHOW_ACCEPT_INVITATION_DIALOG = "TOGGLE_SHOW_ACCEPT_INVITATION_DIALOG";

export const SET_SELECTED_PROJECT_ID = "SET_SELECTED_PROJECT_ID";

export const SET_NOTIFICATION_MESSAGE = "SET_NOTIFICATION_MESSAGE";

export const TOGGLE_SHOW_NOTIFICATION = "TOGGLE_SHOW_NOTIFICATION";

export const SET_NOTIFICATION_TYPE = "SET_NOTIFICATION_TYPE";